import { render, staticRenderFns } from "./TestKitCommitment.vue?vue&type=template&id=35f5d55c&scoped=true&"
import script from "./TestKitCommitment.vue?vue&type=script&lang=js&"
export * from "./TestKitCommitment.vue?vue&type=script&lang=js&"
import style0 from "./TestKitCommitment.vue?vue&type=style&index=0&id=35f5d55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5d55c",
  null
  
)

export default component.exports